import { Box, Typography, useTheme } from "@mui/material";
import { BenefitItemProps } from "./types";
import useResponsive from "@/hooks/useResponsive";

const BenefitItem = ({ icon: Icon, title, description }: BenefitItemProps) => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'md');
  return (
    <Box
      sx={{
        maxWidth: { xs: '100%', md: '445px' },
        ':not(:last-child)': {
          marginBottom: { xs: '24px', md: '0px' },
          marginRight: { xs: '0px', md: '10px' }
        }
      }}
    >
      <Icon width={isMobile ? '24px' : '32px'} height={isMobile ? '24px' : '32px'} />
      <Typography
        variant='h4'
        component='p'
        sx={{
          marginTop: { xs: '18px', md: '22px' },
          marginBottom: { xs: '8px', md: '16px' }
        }}
      >
        {title}
      </Typography>
      <Typography
        variant='subtitle2'
        component='p'
        color={theme.palette.grey[600]}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default BenefitItem;